import { type MetaFunction } from '@remix-run/node'
import Content from './data-usage-privacy.mdx'

export const meta: MetaFunction = () => {
	return [
		{
			title: 'Privacy Policy and Data Usage | Intuizen',
			description:
				'Detailed information about our privacy policy and data usage practices.',
		},
	]
}

export default function DataUsagePrivacyRoute() {
	return (
		<div className="container prose">
			<Content />
		</div>
	)
}
